import React, { useState } from 'react';
import styled from 'styled-components';
import { darken } from 'polished';

const primaryColor = '#EAE8E3'; // Off-white for text
const backgroundColor = '#282c34'; // Dark grey to black for the background
const accentColor = '#C0A383'; // Metallic color for accents
const secondaryAccent = '#A67C52'; // Warm brown for secondary accents

const GeneratorContainer = styled.div`
  background-color: ${backgroundColor};
  padding: 20px;
  margin: 20px auto;
  border-radius: 8px;
  border: 1px solid ${secondaryAccent};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  max-width: 600px;
`;

const GenerateButton = styled.button`
  background-color: ${accentColor};
  color: ${backgroundColor};
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;

  &:disabled {
    background-color: ${darken(0.1, accentColor)};
    cursor: not-allowed;
  }

  &:hover:enabled {
    background-color: ${darken(0.1, accentColor)};
  }
`;

const NPCDetail = styled.p`
  color: ${primaryColor};
  margin: 10px 0;
`;

const DetailLabel = styled.span`
  font-weight: bold;
`;

function NPCGenerator({ race, charClass, sex, age }) {
    const [npc, setNpc] = useState(null);
    const [isGenerating, setIsGenerating] = useState(false);

    const generateNPC = () => {
        setIsGenerating(true);

        const npcData = { race, class: charClass, sex, age };
        fetch('https://cryptic-escarpment-14226-f19de3616500.herokuapp.com/api/generate-npc', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(npcData)
        })
        .then(response => response.json())
        .then(data => {
            setNpc(data);
            setIsGenerating(false);
        })
        .catch(error => {
            console.error('Error fetching NPC:', error);
            setIsGenerating(false);
        });
    };

    return (
        <GeneratorContainer>
            <GenerateButton onClick={generateNPC} disabled={isGenerating}>
                {isGenerating ? 'Generating...' : 'Generate NPC'}
            </GenerateButton>
            {npc && (
                <div>
                    <NPCDetail><DetailLabel>Name:</DetailLabel> {npc.Name}</NPCDetail>
                    <NPCDetail><DetailLabel>Race:</DetailLabel> {npc.Race}</NPCDetail>
                    <NPCDetail><DetailLabel>Class:</DetailLabel> {npc.Class}</NPCDetail>
                    <NPCDetail><DetailLabel>Sex:</DetailLabel> {npc.Sex}</NPCDetail>
                    <NPCDetail><DetailLabel>Age:</DetailLabel> {npc.Age}</NPCDetail>
                    <NPCDetail><DetailLabel>Physical Description:</DetailLabel> {npc.physical_description}</NPCDetail>
                    <NPCDetail><DetailLabel>Backstory:</DetailLabel> {npc.Backstory}</NPCDetail>
                </div>
            )}
        </GeneratorContainer>
    );
}

export default NPCGenerator;







